export const PLUGIN_NAME = 'ecommerce-components';
export const COMPONENT_PREFIX = 'blaze-ecommerce-';
export const TRANSLATION_NAMESPACE = PLUGIN_NAME;
